import { FC } from 'react';

import { IconProps } from './types';

export const HandIcon: FC<IconProps> = ({
	color = 'currentColor',
	height = 22,
	size,
	width = 24,
	className,
}) => (
	<svg
		className={className}
		viewBox="0 0 24 22"
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			d="M4.143 10.93V5c0-1.65 1.346-3 3-3 .39 0 .763.07 1.105.21C8.596.94 9.762 0 11.143 0s2.547.94 2.895 2.21c.342-.14.715-.21 1.105-.21 1.381 0 2.547.94 2.895 2.21.342-.14.715-.21 1.105-.21 1.654 0 3 1.35 3 3v6c0 4.96-4.037 9-9 9h-2c-2.835 0-4.838-.79-6.695-2.63l-3.602-3.6c-.572-.63-.846-1.4-.805-2.2.041-.8.391-1.54.986-2.08.873-.79 2.083-.97 3.116-.56Zm8-1.93c0 .55.447 1 1 1 .553 0 1-.45 1-1V5c0-.55.448-1 1-1s1 .45 1 1v5c0 .55.447 1 1 1 .553 0 1-.45 1-1V7c.003-.55.45-1 1-1 .552 0 1 .45 1 1v6c0 3.86-3.141 7-7 7h-2c-2.288 0-3.819-.59-5.285-2.05l-3.564-3.56c-.179-.2-.27-.46-.256-.72.014-.27.13-.52.329-.69.384-.35.96-.35 1.309-.03l.729.73c.02.02.041.04.063.06l.968.97c.391.39 1.023.39 1.414 0s.391-1.03 0-1.42l-.707-.7V5c0-.55.449-1 1-1 .551 0 1 .45 1 1v4.5c0 .55.448 1 1 1s1-.45 1-1V3c0-.55.449-1 1-1 .551 0 1 .45 1 1v6Z"
			fillRule="evenodd"
		/>
	</svg>
);
